﻿export * from './resultado.component';
export * from './record.component';
